import React from "react";

const YouTube = () => {
    return (
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.6656 2.13722C15.4816 1.44669 14.9395 0.902926 14.2511 0.71838C13.0034 0.38299 8 0.382989 8 0.382989C8 0.382989 2.99666 0.38299 1.7489 0.71838C1.06051 0.902926 0.518324 1.44669 0.334339 2.13722C0 3.38876 0 6.00001 0 6.00001C0 6.00001 0 8.61123 0.334339 9.86288C0.518324 10.5533 1.06051 11.0971 1.7489 11.2817C2.99666 11.617 8 11.617 8 11.617C8 11.617 13.0034 11.617 14.2511 11.2817C14.9395 11.0971 15.4816 10.5533 15.6656 9.86288C16 8.61123 16 6.00001 16 6.00001C16 6.00001 16 3.38876 15.6656 2.13722Z" fill="white"/>
            <path d="M6.36365 8.37079L10.5455 6.00009L6.36365 3.62916V8.37079Z" fill="#3B3838"/>
        </svg>

    );
}

export default YouTube;